import styled from 'styled-components';

export const HighlightedText = styled.span`
  color: ${(props) => props.theme.colors.primary};
`;
